// Columns offered by the vehicle TIMELINE's "Columns" selector. Plate is always on
// (disabled). Keys match CarsTable `dataIndex` so the timeline reuses the same value
// derivations + header labels (see VehicleTimeline/utils/timelineColumns.ts). This is
// a SEPARATE slot from `carColumns` — editing it never affects CarsTable.
const timeTableColumns = [
  {
    label: 'Plate',
    value: 'plate',
    textId: 'fleetadmin.car.table.plate',
    disabled: true,
  },
  {
    label: 'Status',
    value: 'status',
    textId: 'fleetadmin.car.table.status',
    disabled: false,
  },
  {
    label: 'Area',
    value: 'areaId',
    textId: 'fleetadmin.car.table.area',
    disabled: false,
  },
  {
    label: 'Fleet',
    value: 'fleetId',
    textId: 'fleetadmin.car.table.fleet',
    disabled: false,
  },
  {
    label: 'Model',
    value: 'model',
    textId: 'fleetadmin.car.table.model',
    disabled: false,
  },
  {
    label: 'Vehicle VIN',
    value: 'chassisNumber',
    textId: 'fleetadmin.car.table.vin',
    disabled: false,
  },
  {
    label: '# of coming bookings',
    value: 'comingBookings',
    textId: 'fleetadmin.timeline.comingbookings',
    disabled: false,
  },
];

// Plate-only by default; the rest are opt-in via the Columns selector.
export const defaultSelectedTimeTableColumns = ['plate'];

export default timeTableColumns;
